import React, { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Loader from "./Loader";
import UserContext from "../context/UserContext";

function GetUser() {
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState();
  useEffect(() => {
    if (!user) {
      fetch(`${process.env.REACT_APP_API_URL}/user`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else if (res.status === 401) {
            localStorage.removeItem("token");
          } else {
            throw "We're having a server error, please try again";
          }
        })
        .then((data) => setUser(data))
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
    }
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <Outlet />
    </>
  );
}

export default GetUser;
